module.exports = __webpack_public_path__ + "img/news_nori.8e677d50.png";